module.exports = __webpack_public_path__ + "img/data-empty.a97ed149.png";